import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useGetPeriodTotals from '@/hooks/useGetPeriodTotals';

interface ContributionMetaTotalsProps {
  period: string;
}

function ContributionMetaTotals({ period }: ContributionMetaTotalsProps) {
  const { employeeRecords, psp, contributions, ataFees } = useGetPeriodTotals(period);

  return (
    <Box display="flex" gap={4}>
      <Typography variant="caption" component="p">
        Employees: {employeeRecords}
      </Typography>
      <Typography variant="caption" component="p">
        PSP: {psp}
      </Typography>
      <Typography variant="caption" component="p">
        Contributions: {contributions}
      </Typography>
      <Typography variant="caption" component="p">
        ATA Fees: {ataFees}
      </Typography>
    </Box>
  );
}

export default ContributionMetaTotals;
